module.exports = __webpack_public_path__ + "../assets/img/2f23916486e9948cd5da078d252bbc53.svg";